export const downloadCSV = async ({ rootGetters }, {
    payload
}) => {
    payload.organizationId = rootGetters['app/getSelectedOrganization'].id

    const jsonPayload = encodeURIComponent( JSON.stringify(payload) )

    window.open('/downloads/csv-adv-balance-history?_=' + `${jsonPayload}`)
}